import React from "react";

import FilterListIcon from "@mui/icons-material/FilterList";
import { Button } from "@mui/material";
import type { Filters } from "store/types";

import { useFilterOptions } from "../hooks/useFilterOptions";
import { MultiSelectDropdown } from "./MultiSelectDropdown";

interface GlobalFilterBarProps {
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
}

export const GlobalFilterBar: React.FC<GlobalFilterBarProps> = ({ filters, onFiltersChange }) => {
  const { investorOptions, assetClassOptions } = useFilterOptions();
  const filterCount = filters.investors.length + filters.assetClasses.length;

  return (
    <>
      <FilterListIcon sx={{ fontSize: 14, color: "#92a7bc" }} />

      <MultiSelectDropdown
        label="Investor"
        options={investorOptions}
        selected={filters.investors}
        onChange={(investors) => onFiltersChange({ ...filters, investors })}
        tone="blue"
      />

      <MultiSelectDropdown
        label="Asset Class"
        options={assetClassOptions}
        selected={filters.assetClasses}
        onChange={(assetClasses) => onFiltersChange({ ...filters, assetClasses })}
        tone="green"
      />

      {filterCount > 0 && (
        <Button
          onClick={() => onFiltersChange({ investors: [], assetClasses: [] })}
          sx={{ color: "#d93e3e", fontSize: 12, fontWeight: 600, textTransform: "none", p: "4px 8px", minWidth: 0 }}
        >
          Clear All
        </Button>
      )}
    </>
  );
};
